import React, {useState} from "react";

import Modal from "components/Modal";
import { INewsElement } from "pages/NewsPage";

interface IModal {
  type: string;
  data?: INewsElement;
  onClose?: () => void;
}

const ShowNewsModals: React.SFC<IModal> = ({type, data, onClose}) => {
  const [modal, showModal] = useState<IModal | undefined>(undefined);

  return(
    <React.Fragment>
      {/* Modals */}
      {/* Показ с картинкой */}
      {type === "showImage" && data && (
        <Modal onClose={onClose!}>
          <img src={data.image} />
          <div className="px-4 mt-4 mb-4">
            <h3>{data.name}</h3>
            <p className="pre-wrap">{data.description}</p>
          </div>
          <div className="text-center px-4 px-md-0">
            <button
              onClick={onClose}
              className="btn btn-primary"
              data-dismiss="modal"
              aria-label="Close"
            >
              Закрыть
            </button>
          </div>
          {/* <a onClick={hideModal} className="reg__clean">Отмена</a> */}
        </Modal>
      )}

      {/* Показ только текст */}
      {type === "show" && data && (
        <Modal onClose={onClose!}>
          <div className="px-4 mt-4 mb-4 pt-3">
            <h3>{data.name}</h3>
            <p className="pre-wrap">{data.description}</p>
          </div>
          <div className="text-center">
            <button
              onClick={onClose}
              className="btn btn-primary"
              data-dismiss="modal"
              aria-label="Close"
            >
              Закрыть
            </button>
          </div>
          {/* <a onClick={hideModal} className="reg__clean">Отмена</a> */}
        </Modal>
      )}
    </React.Fragment>
  );
}

export default ShowNewsModals;